import AsYouType from "./AsYouType.js";
function formatIncompletePhoneNumber(value, optionsOrDefaultCountry, metadata) {
  return metadata || (metadata = optionsOrDefaultCountry, optionsOrDefaultCountry = void 0), new AsYouType(optionsOrDefaultCountry, metadata).input(value);
}
export {
  formatIncompletePhoneNumber as default
};
//# sourceMappingURL=formatIncompletePhoneNumber.js.map
